import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  itemMenuLink: {
    padding: '2px',
    borderRadius: '8px',
    '& span': {
      color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontWeight: '600',
      marginLeft: '1px',
    },
    '& svg': {
      marginLeft: '4px',
      color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
    },
    [theme.breakpoints.up('lg')]:{
      padding: '4px',
    }
  },
  selected: {
    background: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    '& svg': {
      color: theme.palette.white_100.main
    },
    '& span': {
      color: theme.palette.white_100.main
    }
  }
}))
